import * as React from "react";
import { observer } from "mobx-react";
import { CruiseWizardStateProps } from "../typings";

export const CruiseHiddenSearchData = observer(({ cruiseWizardState }: CruiseWizardStateProps) => {
  const { cruiseLine } = cruiseWizardState.config;

  return <input type="hidden" id="cruiseLine" data-testid="cruise-line" name="cruise-line" value={cruiseLine} />;
});
